import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { set_RoadmapData } from "../../../Redux/slices/dataSlice";
import { get_roadmap } from "http/components/Requests";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useEffect } from "react";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";

export default function RoadmapSteps() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { roadmap } = useSelector((state) => ({
    roadmap: state.data.roadmap,
  }));

  useEffect(() => {
    getRoadmapData();
  }, []);

  const getRoadmapData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_roadmap();
    if (CheckApiStatus(response))
      dispatch(set_RoadmapData(response.data.infos));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      {roadmap &&
        roadmap.map((item) => {
          return (
            <div
              id={`phase${item.id}`}
              className="each-phase"
              key={`phase-${item.id}`}
            >
              <div className="inner-content">
                <div className="inner-head">
                  <p className="index set-Audiowide-font">{t(item.title)}</p>
                  <p className="set-Audiowide-font">{t(item.description)}</p>
                </div>
                {item.subcategories.map((i) => {
                  return (
                    <div
                      className={`inner-phase ${
                        i.status === 5 ? "disable" : ""
                      }`}
                      key={`phase-${item.id}-${i.id}`}
                    >
                      <div className="inner-phase-status">
                        <div
                          className={`inner-phase-icon status-${i.status} ${
                            i.value === 100 ? "done" : "proccess"
                          } `}
                        >
                          {i.status === 3 && i.value !== 100 && (
                            <div className="circular-progress">
                              <CircularProgress
                                variant="determinate"
                                size={55}
                                value={i.value}
                              />
                            </div>
                          )}
                          {
                            {
                              4: <Icons.CheckCircleFill />,
                              3: <Icons.PlayCircleFill />,
                              2: <Icons.StopCircleFill />,
                              5: <Icons.SlashCircleFill />,
                            }[i.status]
                          }
                        </div>
                        {i.status !== 5 && (
                          <p className="inner-phase-step d-block d-md-none">
                            {t(i.title)}
                          </p>
                        )}
                      </div>
                      <p className="inner-phase-description">
                        {t(i.description)}
                      </p>
                      {i.status !== 5 && (
                        <p className="inner-phase-step d-none d-md-block">
                          {t(i.title)}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
    </>
  );
}
